import { OnBoardingFlowType } from '@mindly/ui-components';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AuthState = {
  isLinkUserExist: boolean;
  signUpEmail: string;
  action: 'signUp' | 'signIn' | 'link' | null;
  onBoardingUserId?: string;
  newOnBoardingAnswers?: {
    [key: string]: string[];
  };
  newOnBoardingData?: {
    id: string;
    name: string;
    type: string;
    experiment?: string | null;
  };
  onboardingData?: { theme: OnBoardingFlowType['theme']; theme_v2: OnBoardingFlowType['theme_v2'] } | null;
  isTokenInit: boolean;
  isWebToWebAuth: boolean;
  signUpName: {
    firstName?: string;
    lastName?: string;
  };
  signUpDoB: string;
  signUpCountry: string;
  signUpUSState: string;
  redirectTo: string | null;
  isNeedAdditionalData: boolean;
};

const initialState: AuthState = {
  isLinkUserExist: false,
  signUpEmail: '',
  action: null,
  onBoardingUserId: undefined,
  newOnBoardingAnswers: undefined,
  onboardingData: null,
  isTokenInit: false,
  isWebToWebAuth: false,
  signUpName: {
    firstName: '',
    lastName: '',
  },
  newOnBoardingData: sessionStorage.getItem('newOnBoardingDataState')
    ? JSON.parse(sessionStorage.getItem('newOnBoardingDataState') as string)
    : undefined,
  signUpCountry: '',
  signUpUSState: '',
  signUpDoB: '',
  redirectTo: null,
  isNeedAdditionalData: false,
};

const authReducer = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    setIsLinkUserExist(state, action: PayloadAction<boolean>) {
      state.isLinkUserExist = action.payload;
    },
    setSignUpEmail(state, action: PayloadAction<string>) {
      state.signUpEmail = action.payload;
    },
    setAuthAction(state, action: PayloadAction<AuthState['action']>) {
      state.action = action.payload;
    },
    setSignUpName(state, action: PayloadAction<AuthState['signUpName']>) {
      state.signUpName = {
        ...state.signUpName,
        ...action.payload,
      };
    },
    updateSignUpData(state, action: PayloadAction<Partial<AuthState>>) {
      return (state = {
        ...state,
        ...action.payload,
      });
    },
    setOnBoardingUserId(state, action: PayloadAction<string | undefined>) {
      state.onBoardingUserId = action.payload;
    },
    setNewOnBoardingAnswers(
      state,
      action: PayloadAction<{
        [key: string]: string[];
      }>
    ) {
      state.newOnBoardingAnswers = action.payload;
    },
    setNewOnboardingData(state, action: PayloadAction<AuthState['newOnBoardingData']>) {
      state.newOnBoardingData = action.payload;
    },
    setOnBoardingData(state, action: PayloadAction<AuthState['onboardingData']>) {
      state.onboardingData = action.payload;
    },
    setIsTokenInit(state, action: PayloadAction<boolean>) {
      state.isTokenInit = action.payload;
    },
    setIsWebToWebAuth(state, action: PayloadAction<boolean>) {
      state.isWebToWebAuth = action.payload;
    },
    setRedirectTo(state, action: PayloadAction<string | null>) {
      state.redirectTo = action.payload;
    },
    resetAuthState(state) {
      return initialState;
    },
  },
});

export const {
  setSignUpEmail,
  setAuthAction,
  resetAuthState,
  setSignUpName,
  setOnBoardingUserId,
  setNewOnBoardingAnswers,
  setNewOnboardingData,
  setIsTokenInit,
  setIsWebToWebAuth,
  setRedirectTo,
  updateSignUpData,
  setOnBoardingData,
  setIsLinkUserExist,
} = authReducer.actions;
export default authReducer.reducer;
